// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import VueMq from 'vue-mq'
import Vuetify from 'vuetify'
import axios from 'axios'
import App from './App'
import store from './store'
import { createRouter } from './router'
import 'vuetify/dist/vuetify.min.css'
import 'es6-promise/auto'
import { sync } from 'vuex-router-sync'
import {FETCH_USER} from './store/mutation-types'
import VueAnalitycs from 'vue-analytics'
import { registerValidSW } from './registerServiceWorker'

Vue.use(VueMq)
Vue.use(Vuetify)

Vue.config.productionTip = false
const router = createRouter(store)
sync(store, router)

if (process.env.NODE_ENV === 'production') {
  Vue.use(VueAnalitycs, {
    id: 'UA-125627631-1',
    router
  })
}

/* Axios default URL */
axios.defaults.baseURL = process.env.API_URL

const token = localStorage.getItem('token')
if (token) {
  axios.defaults.headers.common['Authorization'] = 'Bearer ' + token
  store.dispatch(FETCH_USER)
}

registerValidSW('service-worker.js')

/* eslint-disable no-new */
new Vue({
  el: '#app',
  store,
  router,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js